<template>
  <div>
    <div class="x-oilBox" v-if="goods">
      <div class="border"></div>
      <div class="middle flex">
        <div class="imgBox"><img :src="goods.image" /></div>
        <div class="flex1">
          <div
            class="title"
            v-html="goods.name.replace(/(\r\n|\n|\r)/, '<br />')"
          ></div>
          <div class="spec">规格：{{ goods.volume }}</div>
          <div class="money">
            ￥<span style="font-size: 16px"
              >{{ goods.price }}/{{ goods.unitName }}</span
            >
          </div>
        </div>
      </div>
      <div class="border"></div>
    </div>
    <div style="margin-bottom: 50px;">
      <div class="oilMain vux-1px-b vux-1px-t">
        <div class="vux-1px-b" style="pointer-events: none;">
          <x-input
            :title="title1"
            text-align="right"
            placeholder="输入订购数量"
            v-model="goods.quantity"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b disabled">
          <selector
            title="订购主体"
            direction="rtl"
            placeholder="请选择订购主体"
            v-model="clientType"
            :options="typeList"
          ></selector>
        </div>
        <div
          class="vux-1px-b"
          v-if="clientType == 2"
          :class="ifDisabled || type == 'admin' ? 'disabled' : ''"
        >
          <selector
            v-if="unSelect"
            title="买家"
            direction="rtl"
            placeholder="请选择买家"
            v-model="params.companyId"
            @on-change="companyChange"
            :options="companyList"
          ></selector>
          <x-input
            v-else
            title="买家"
            text-align="right"
            disabled="disabled"
            placeholder="请选择买家"
            v-model="params.contactName"
            placeholder-align="right"
          >
          </x-input>
        </div>
        <div class="vux-1px-b" v-if="clientType == 1">
          <x-input
            title="买家"
            text-align="right"
            disabled="disabled"
            placeholder="请选择买家"
            v-model="params.contactName"
            placeholder-align="right"
          >
          </x-input>
        </div>
        <div
          class="vux-1px-b"
          v-if="clientType == 2"
          style="pointer-events: none;"
        >
          <x-input
            title="联系人"
            text-align="right"
            disabled="disabled"
            placeholder="输入联系人"
            v-model="params.clientName"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b" style="pointer-events: none;">
          <x-input
            title="联系方式"
            text-align="right"
            disabled="disabled"
            placeholder="输入联系方式"
            v-model="params.contactPhone"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b" style="pointer-events: none;">
          <x-input
            title="渔船编号"
            text-align="right"
            v-model="params.clientShipCode"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b" style="pointer-events: none;">
          <x-input
            title="付款方式"
            text-align="right"
            v-model="paymentMethod"
            placeholder-align="right"
          ></x-input>
        </div>
        <div style="pointer-events: none;">
          <checklist
            :options="commonList"
            required="true"
            v-model="checkType"
            :max="1"
          ></checklist>
        </div>
        <div
          class="vux-1px-b"
          style="pointer-events: none;"
          v-if="params.type == 1"
        >
          <x-input
            title="用油时间"
            text-align="right"
            v-model="params.useTime"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b" style="pointer-events: none;">
          <x-input
            title="经度"
            text-align="right"
            placeholder="请输入"
            v-model="params.longitude"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b" style="pointer-events: none;">
          <x-input
            title="纬度"
            text-align="right"
            placeholder="请输入"
            v-model="params.latitude"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b" style="pointer-events: none;">
          <selector
            title="溯源"
            direction="rtl"
            v-model="params.origin"
            :options="originList"
          ></selector>
        </div>
        <div v-if="params.type == 1" style="pointer-events: none;">
          <x-textarea title="用油地址" v-model="params.address"></x-textarea>
        </div>
      </div>
      <div class="oilMain vux-1px-b vux-1px-t">
        <div class="vux-1px-b" style="pointer-events: none;">
          <x-textarea title="订单备注" v-model="params.remark"></x-textarea>
        </div>
        <div class="heji vux-1px-b" v-if="params.type != 1">
          <span style="margin-right: 5px;pointer-events: none;">合计金额:</span
          >¥{{ params.orderAmount }}
        </div>
        <div class="vux-1px-b" style="pointer-events: none;">
          <x-input
            title="截止时间"
            text-align="right"
            v-model="params.deadLine"
            placeholder-align="right"
          ></x-input>
        </div>
      </div>
    </div>
    <div class="footer flex">
      <div class="flex1">
        <span v-if="params.type == 1">
          <span class="footerLine1">合计：</span>
          <span style="color: #FF3600">¥{{ params.orderAmount }}</span>
        </span>
        <span v-else>
          <span class="footerLine1"
            >预付：<span style="color: #FF3600">￥</span></span
          >
          <input
            class="yufu"
            style="pointer-events: none;"
            v-model="params.prepaidAmount"
          />
        </span>
      </div>
      <div class="buyButton" style="width: 160px" v-if="type == 'admin'">
        点击右上角进行分享
      </div>
      <div class="buyButton" v-else @click="confirm">确认订单</div>
    </div>
    <confirm
      v-model="show"
      title="提示"
      confirm-text="确定"
      @on-confirm="onConfirm"
    >
      <p style="text-align:center;">已下单成功，请点击查看</p>
    </confirm>
  </div>
</template>

<script>
import { getTempOrderDetail, clientOrderConfirm } from "@/api/order";
import { Checklist } from "vux";
import { getType } from "../../utils/auth";
import { getCompanyList } from "../../api/identify";

export default {
  name: "shareOrder",
  props: {
    id: {
      type: String
    }
  },
  components: {
    Checklist
  },
  data() {
    return {
      originList: [
        { key: "1", value: "默认" },
        { key: "2", value: "溯源" }
      ],
      commonList: [
        { key: "1", value: "立即付款" },
        { key: "2", value: "预定付款（提前预定，随时用）" }
      ],
      goods: "",
      typeList: [
        {
          key: "1",
          value: "个人"
        },
        {
          key: "2",
          value: "公司"
        }
      ],
      params: {
        contactPhone: "",
        origin: 1
      },
      title1: "",
      clientId: "",
      clientType: "",
      checkType: "",
      type: "",
      paymentMethod: "",
      show: false,
      orderId: "",
      ifDisabled: false,
      companyList: [],
      unSelect: false
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  mounted() {
    getCompanyList()
      .then(res => {
        if (res) {
          this.companyList = res.map(x => {
            return {
              key: x.id,
              value: x.companyName
            };
          });
        }
      })
      .catch(err => {
        this.$showError(err);
      });
    this.type = getType();
    this.getTempOrderDetail();
  },
  methods: {
    onConfirm() {
      this.$router.push("/order/" + this.orderId);
    },
    getTempOrderDetail() {
      let that = this;
      getTempOrderDetail({ id: this.$route.params.id })
        .then(res => {
          let postData = {
            id: res.id,
            title: res.details[0].name,
            image: res.details[0].image
          };
          try {
            window._czc.push(["_trackEvent", "操作", "分享"]);
          } catch (err) {
            console.log(err);
          }

          // eslint-disable-next-line
          wx.miniProgram.postMessage({ data: JSON.stringify(postData) });

          that.params = res;
          that.clientType = res.buyerType;
          if (that.type == "user") {
            if (that.clientType == 1) {
              if (res.contactName) {
                that.params.contactName = res.contactName;
                that.params.contactPhone = res.contactPhone;
              } else if (that.userInfo) {
                const { realName, phone } = that.userInfo;
                that.params.contactName = realName;
                that.params.contactPhone = phone;
              }
              that.params.companyId = "";
            }
            if (that.clientType == 2) {
              if (res.contactName) {
                that.params.contactName = res.contactName;
                that.params.contactPhone = res.contactPhone;
              } else {
                that.unSelect = true;
                if (that.userInfo) {
                  const { realName, phone } = that.userInfo;
                  that.params.clientName = realName;
                  that.params.contactPhone = phone;
                }
              }
              that.params.companyId = res.clientCompanyId;
            }
            if (res.clientCompanyId) {
              that.ifDisabled = true;
            }

            // if(res.contactName){
            //   that.params.contactName = res.contactName;
            //   that.params.contactPhone = res.contactPhone;
            // }
            // else {
            //   if(that.clientType==2){
            //     that.unSelect=true
            //   }
            //   if (that.userInfo) {
            //     const { realName, phone } = that.userInfo;
            //     that.params.clientName = realName;
            //     that.params.contactPhone = phone;
            //   }
            // }
            //
            //
            // // if (res.contactName) {
            //
            // if (that.clientType == 1) {
            //   that.params.companyId = "";
            // } else {
            //   that.params.companyId = res.clientCompanyId;
            // }
          }

          that.title1 = "订购数量（" + res.details[0].unitName + "）";

          that.goods = res.details[0];
          if (res.paymentMethod == 2) {
            that.paymentMethod = "线下";
          } else {
            that.paymentMethod = "线上";
          }

          // if (res.buyerType == 1) {
          //   that.clientType = "个人";
          // } else {
          //   that.clientType = "公司";
          // }
          that.checkType = res.type + "";
        })
        .catch(err => {
          this.$showMessage(err);
        });
    },
    companyChange(e) {
      if (e) {
        for (let i = 0; i < this.companyList.length; i++) {
          if (this.companyList[i].key == e) {
            this.params.contactName = this.companyList[i].value;
          }
        }
      } else {
        this.params.contactName = "";
        this.params.companyId = "";
      }
    },
    confirm() {
      let res = confirm("是否确认订单？");
      if (res) {
        this.$vux.loading.show();
        let req = {
          clientType: this.clientType,
          companyId: "",
          contactName: this.params.contactName,
          contactPhone: this.params.contactPhone,
          id: this.$route.params.id
        };
        if (this.clientType == 2) {
          req.companyId = this.params.companyId;
        }
        if (this.clientType == 2 && !req.companyId) {
          this.$vux.loading.hide();
          this.$showMessage("请选择公司");
        } else {
          clientOrderConfirm(req)
            .then(() => {
              this.$vux.loading.hide();
              this.$router.push({ path: "/order" });
            })
            .catch(err => {
              this.$vux.loading.hide();
              if (err.code && err.code == 38600) {
                this.orderId = err.msg;
                this.show = true;
              } else {
                this.$showMessage(err);
              }
            });
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
.disabled {
  pointer-events: none;
}
.customer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  overflow: hidden;
}
.yufu {
  display: inline-block;
  float: left;
  border: none;
  color: #ff3600;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  width: 240px;
}
.heji {
  display: block;
  overflow: hidden;
  padding: 20px 30px;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.x-oilBox {
  position: relative;
  background: #fff;
  margin: 10px 0;
  overflow: hidden;
  .border {
    background: url("../../assets/border.png") repeat;
    height: 1px;
    width: 100%;
  }
}
.middle {
  padding: 20px 30px;
}
.imgBox {
  width: 140px;
  height: 140px;
  overflow: hidden;
  margin-right: 30px;
}
.imgBox img {
  width: 100%;
  height: 100%;
  display: block;
}
.title {
  font-size: 16px;
  line-height: 32px;
  margin-bottom: 10px;
  color: #111111;
}
.spec {
  font-size: 12px;
  line-height: 32px;
  color: #919191;
  margin-bottom: 34px;
}
.money {
  font-size: 16px;
  color: #ff3600;
}

.oilMain {
  background: #fff;
  font-size: 14px;
  overflow: hidden;
  margin: 20px 0;
}
.oilText input {
  width: 100%;
  text-align: right;
  border: none;
  height: 40px;
  line-height: 40px;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100px;
  background: #fff;
  line-height: 100px;
  border-top: 1px solid #e8e8e8;
}
.buyButton {
  width: 220px;
  height: 100px;
  background: #039df8;
  color: #fff;
  font-size: 15px;
  text-align: center;
}
.footerLine1 {
  margin-left: 30px;
  float: left;
}
</style>
